import Transaction from '@/models/Transaction';
import { parseTransactionDate } from '@/helpers/dateHelper';
import { isFutureRow } from './futureTransactions';

/**
 * HAT-1448: a standalone fee movement (עמלה חודשית, דמי מסופון, עמלת הקמת הו"ק, עמלה ידנית).
 * Management decided these stay off the board and appear only in the Excel export, but they
 * still come off the running balance.
 */
export const isFeeRow = (row: Transaction): boolean => Boolean(row.kind?.includes('עמלה'));

/**
 * HAT-1448: the date the running balance starts from, when this row's balance is missing
 * only because the row is older than it. Null otherwise: a row that has a balance, a future
 * row (no balance ahead of today, and a dash says so), or a fund whose balance response does
 * not carry the date.
 */
export const balanceNotComputedBefore = (row: Transaction, runningBalanceFrom: string | null | undefined): Date | null => {
  if (isFutureRow(row) || row.cumulativeAmount) return null;
  const from = parseTransactionDate(runningBalanceFrom);
  const date = parseTransactionDate(row.date);
  return from && date && date < from ? from : null;
};
